"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var callback_1 = tslib_1.__importDefault(require("./callback"));
var user_1 = tslib_1.__importDefault(require("./user"));
var logout_1 = tslib_1.__importDefault(require("./logout"));
var constants_1 = require("../../shared/utils/constants");
function handleAuth(options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    return function (req, res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var logout, cookieOptions, tokenRefreshMargin, route, _a;
        var _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    logout = options.logout;
                    cookieOptions = tslib_1.__assign(tslib_1.__assign({}, constants_1.COOKIE_OPTIONS), options.cookieOptions);
                    tokenRefreshMargin = (_b = options.tokenRefreshMargin) !== null && _b !== void 0 ? _b : constants_1.TOKEN_REFRESH_MARGIN;
                    route = req.query.supabase;
                    route = Array.isArray(route) ? route[0] : route;
                    _a = route;
                    switch (_a) {
                        case 'callback': return [3 /*break*/, 1];
                        case 'user': return [3 /*break*/, 2];
                        case 'logout': return [3 /*break*/, 4];
                    }
                    return [3 /*break*/, 5];
                case 1: return [2 /*return*/, (0, callback_1.default)(req, res, { cookieOptions: cookieOptions })];
                case 2: return [4 /*yield*/, (0, user_1.default)(req, res, {
                        cookieOptions: cookieOptions,
                        tokenRefreshMargin: tokenRefreshMargin
                    })];
                case 3: return [2 /*return*/, _c.sent()];
                case 4: return [2 /*return*/, (0, logout_1.default)(req, res, tslib_1.__assign({ cookieOptions: cookieOptions }, logout))];
                case 5:
                    res.status(404).end();
                    _c.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
exports.default = handleAuth;
//# sourceMappingURL=auth.js.map